import React from 'react';
import ArrowUpwardIcon from '@material-ui/icons/KeyboardArrowUp';
import ArrowDownwardIcon from '@material-ui/icons/KeyboardArrowDown';
import IconButton from '@material-ui/core/IconButton';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit,editOrder,moveRow,index}) => {
    const rows = [
        { label: 'Shed Type', value: data.shedTypeName },
    ];

    // Up/down arrows next to the 3 dots while editing the order
    if (editOrder) {
        rows.push({
            label: 'Order',
            value: <>
                <IconButton size="small" onClick={() => moveRow(index, -1)}><ArrowUpwardIcon /></IconButton>
                <IconButton size="small" onClick={() => moveRow(index, 1)}><ArrowDownwardIcon /></IconButton>
            </>,
            inHeader: true,
            hideLabel: true,
        });
    }

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.name}
            id={data.orderID}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
